import { Router } from 'vue-router'
import { RouteRecord } from 'src/router'

/**
 * [<module_name>, <enabled>]
 */
const modules = new Map([
  ['experiences', true],
  ['home', true],
  ['insights', true],
  ['packs', true],
  ['profile', true],
  ['resources', true],
  ['search', true],
])

export const addRoutes = async (router: Router) => {
  await Promise.all(
    Array.from(modules).map(async (module): Promise<void> => {
      const [name, enabled] = module

      if (!enabled) {
        return
      }

      const { routes } = await import(`./${name}/router/index.ts`)

      routes.forEach((route: RouteRecord) => {
        if (route.noLayout) {
          route.path = `/${route.path}`
          return void router.addRoute(route)
        }

        router.addRoute('root', route)
      })
    })
  )
}
